<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100      
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getPartnersList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addPartners type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_partners") }}

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%")
                  span(:title="$t('ui.image')") {{ $t("ui.image") }}
                th(width="7%")
                  span(:title="$t('ui.link')") {{ $t("ui.link") }}
                th(width="10%")
                  span(:title="$t('ui.partner_name')") {{ $t("ui.partner_name") }}
                th.text-center(width="6%" @click="sortOrder('seq')")
                  span(:title="$t('ui.sequence')") {{ $t("ui.sequence") }}
                  .float-right
                    i(:class="changeSortKey('seq')")
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="10%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                  .float-right
                    i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="partnersList.length == 0")
                td(:colspan="isEditAccess ? '11' : '10'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(
                v-for="(item, index) in partnersList"
              )
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(v-if="item.img_url")
                    b-img.fiximg(:src="imagePath + item.img_url" @error="handleImageError")
                td
                  span(:title="item.href") {{ item.href }}
                td
                  span(:title="item.partner_name") {{ item.partner_name }}
                td
                  b-form-select.text-center(v-model="item.seq" @change="!isEditAccess ? null : changedSeq(item, $event)" size="sm" :disabled="!isEditAccess")
                    option(value=0 disabled) 0
                    option(v-for="index in partnersListLength" :key="index") {{ index }}
                    option(v-if="partnersListLength < 100" :key="100") 100
                td.actions.text-center(v-if="isEditAccess")
                  span.mr-1
                    a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                  span.mr-1
                    a.fa.fa-trash.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="onDelete(item)" :title="$t('ui.delete')")
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

  addpartners(@clicked="addPartners" @failed="handleFailed")
  editpartners(ref="editpartners" :item="editSelectedPartners" @clicked="afterEditPartners" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addpartners from "@/components/cms/addPartners.vue";
import editpartners from "@/components/cms/editPartners.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addpartners,
    editpartners
  },
  props: {
    currTab: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    partnersList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: null,
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedPartners: null,
    imagePath: config.viewImageUrl,
    maxSeq: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeCms;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cms");
    },
    partnersListLength() {
      if (this.partnersList) {
        if(this.maxSeq > this.partnersList.length) {
          return this.maxSeq;
        } else {
          return this.partnersList.length;
        }
      } else {
        return 0;
      }
    },
  },
  mounted: function() {},
  methods: {
    refresh() {
      this.getPartnersList(true);
    },
    handleImageError(event) {
      event.target.src = 'https://placehold.co/150?text=No+Image'; // Set fallback image
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getPartnersList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    afterEditPartners: function() {
      this.getPartnersList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_partners"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedPartners = e;
      this.$refs.editpartners.$refs.editPartners.show();
    },
    changedSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_partner_seq_confirm", { id: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSeq(item, eventStatus);
          } else {
            this.getPartnersList();
          }
        });
    },
    confirmSeq: function(item, seq) {
      let url = config.partnersUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        partner_id: item.id,
        seq: seq
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPartnersList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getPartnersList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onDelete: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_partner_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPartnersDelete(item);
          }
        });
    },
    confirmPartnersDelete: function(item) {
      let url = config.partnersRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        partner_id: item.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPartnersList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getPartnersList: function(isSearch) {
      let url = config.partnersListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_type: this.sortType,
        sort_key: this.sortKey,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };


      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.partnersList = response.data.dt;
                this.totalRow = this.partnersList.length > 0 ? this.partnersList[0].totalrows : 0;
                if(this.partnersList.length > 0) {
                  // Filter out objects with seq < 100, then find the max seq value
                  const maxSeq = this.partnersList
                      .filter(item => item.seq < 100) // Keep only items with seq < 100
                      .reduce((max, item) => Math.max(max, item.seq), -Infinity); // Find the maximum seq

                  this.maxSeq = maxSeq;
                } else {
                  this.maxSeq = 0;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addPartners: function() {
      this.getPartnersList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_partners"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'announcementbanner') return
      this.$store.dispatch("layout/setPageSizeCms", pageSize);
      this.currentPage = 1;
      this.getPartnersList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getPartnersList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.fiximg {
  height:40px; 
  width:100%;
}

td {
  vertical-align: middle !important;
}
</style>